import { SamplePack } from '@arpeggi/shared'
import { FC } from 'react'
import { useSamplePackNotifications } from '../../../__legacy__/queries/samplePacks'
import { ActivityNotification } from '../../notifications'
import { Recent } from '../primitives'
import { RecentLoader } from './RecentLoader'

export const SPRecentActivity: FC<{ sp: SamplePack }> = ({ sp }) => {
  const { data, isLoading } = useSamplePackNotifications({
    id: sp.id,
    params: { perPage: 3, order: 'desc' }
  })

  return (
    <Recent.Root>
      <Recent.Header>
        <Recent.Title>Recent Activity</Recent.Title>
        <Recent.Stats>{`${sp.soundRemixCount} uses • ${sp.soundFavoriteCount} likes`}</Recent.Stats>
      </Recent.Header>
      {(() => {
        if (isLoading || !data) return <RecentLoader />
        return data.pages[0].data.map((notification) => (
          <ActivityNotification key={notification.id} notification={notification} />
        ))
      })()}
    </Recent.Root>
  )
}
